import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// SAPITO_AXIOS_NORMALIZE_V1
// Normalise /api/tracks and /api/artists when backend returns a plain array instead of {tracks:[...]} / {artists:[...]}.
import axios from "axios";
axios.interceptors.response.use((res) => {
  try {
    const raw = (res && res.config && res.config.url) ? String(res.config.url) : "";
    const url = raw.split("?")[0];

    // never touch admin endpoints
    if (url.includes("/admin/")) return res;

    if (Array.isArray(res.data)) {
      if (url.endsWith("/api/tracks") || url.endsWith("/tracks")) res.data = { tracks: res.data };
      if (url.endsWith("/api/artists") || url.endsWith("/artists")) res.data = { artists: res.data };
    }
  } catch (e) {}
  return res;
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
